import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, deleteDoc, collection, getDocs, getDoc } from 'firebase/firestore';

import DeleteLogo from '../../images/delete.svg';
import EditLogo from '../../images/edit.svg';
import {
    TableButton,
    PostListContainer,
    TableContainer,
    TableTd,
    TableTh,
    TableTr
} from '../styled-components';
import { Loader } from '../../components';
import { db } from '../../utils/firebase-config';

export const PostListView = ({ postList, getPostList, getPostDetail }) => {
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);

    const getData = async () => {
        const titlesData = [];
        setIsloading(true);
        const querySnapshot = await getDocs(collection(db, 'blog-data'));
        querySnapshot.docs.forEach((blog) => {
            if (blog.data()) {
                titlesData.push({ ...blog.data(), uuid: blog.id });
            }
        });
        getPostList(titlesData);
        setIsloading(false);
    };

    const deleteData = async (uuid, title) => {
        if (confirm(`Are you sure you want to delete -- ${title}`)) {
            if (uuid) {
                setIsloading(true);
                await deleteDoc(doc(db, 'blog-data', String(uuid)));
                getData();
                setIsloading(false);
            }
        } else {
            // Not deleted
        }
    };

    const editData = async (uuid, title) => {
        if (confirm(`Are you sure you want to edit -- ${title}`)) {
            if (uuid) {
                setIsloading(true);
                const querySnapshot = await getDoc(doc(db, 'blog-data', String(uuid)));
                getPostDetail(querySnapshot.data());
                navigate(`/admin-space/${uuid}/edit`);
                setIsloading(false);
            }
        } else {
            // Not deleted
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const Table = () => {
        return (
            <TableContainer>
                <thead>
                    <TableTr>
                        <TableTh>POST</TableTh>
                        <TableTh>Delete</TableTh>
                        <TableTh>Edit</TableTh>
                    </TableTr>
                </thead>
                <tbody>
                    {postList.map((row, index) => {
                        return (
                            <TableTr key={index}>
                                <TableTd isPost={true}>{row.title}</TableTd>
                                <TableTd>
                                    <TableButton onClick={() => deleteData(row?.uuid, row?.title)}>
                                        <img className='w-50' src={DeleteLogo} />
                                    </TableButton>
                                </TableTd>
                                <TableTd>
                                    <TableButton onClick={() => editData(row?.uuid, row?.title)}>
                                        <img className='w-50' src={EditLogo} />
                                    </TableButton>
                                </TableTd>
                            </TableTr>
                        );
                    })}
                </tbody>
            </TableContainer>
        );
    };

    return (
        <PostListContainer>
            {isloading ? <Loader /> : <Table/>}
        </PostListContainer>
    );
};

